import { useNavigate } from 'react-router-dom';
import RedirectButton from '../../components/Button/RedirectButton';
import { useContext } from 'react';
import CookiesBanner from '../../components/CookiesBanner';

interface RedirectSignInProps {
  context: any;
}

export default function RedirectSignIn({ context }: RedirectSignInProps) {
  const navigate = useNavigate();
  const { originDomainForm } = useContext<any>(context);

  function redirectToLogin() {
    const url =
      originDomainForm === 'signup'
        ? '/signin'
        : originDomainForm === 'sbt/signup'
          ? '/sbt/signin'
          : '/videos/signin';
    navigate(url);
  }

  return (
    <div className="card__footer">
      <div className="card__footer-actions">
        <RedirectButton
          name="Já tem uma Conta SBT? Entre agora."
          onClick={redirectToLogin}
        />
        <p
          className="account-detail"
          onClick={() => {
            console.log('TODO');
          }}
        >
          Pra que ter uma Conta SBT?
        </p>
      </div>

      <CookiesBanner />
    </div>
  );
}
